import React, { useRef } from "react"

import {
  spacing,
  IconArrowLeftMedium,
  IconInfoMedium,
  IconCrossMedium,
} from "@izettle/otto"
import { useLocalization } from "@izettle/tenko-react"

import { useModal } from "@/core/components/modal"
import {
  Header,
  IconButton,
  HeaderContent,
  LogoSmall,
  Alignments,
} from "@/core/components/shared"
import { useSlider } from "@/core/components/slider"
import {
  PrivacyPolicyFrom,
  TrackingAction,
  useSignUpTracking,
} from "@/modules/sign-up/hooks/tracking-sign-up"

import { Modals } from "./types"

type Props = {
  purchaseUuid: string
  orgPrivacyPolicyLink?: string
  orgImageUrl?: string
  slidesWithNoHeader: number[]
  slidesToHideInfoIcon?: number[]
  slidesToSkip?: number[]
}

export default function Navigation({
  purchaseUuid,
  orgPrivacyPolicyLink,
  orgImageUrl,
  slidesWithNoHeader,
  slidesToHideInfoIcon = [],
  slidesToSkip = [],
}: Props) {
  const ref = useRef(null)
  const { text } = useLocalization()
  const { goPrev, index, goTo, params } = useSlider()
  const [showPolicyModal] = useModal(Modals.Policy)
  const { track } = useSignUpTracking(purchaseUuid)

  const { customerGoBack } = params

  const handleGoBack = () => {
    if (slidesToSkip.includes(index - 1)) {
      goTo(index - 2)
    } else {
      goPrev()
    }
  }

  const handlecustomerGoBack = () => {
    goTo(customerGoBack as number)
  }

  const handlePolicyClicked = () => {
    showPolicyModal(ref)
    track(TrackingAction.ViewedPrivacyPolicy, {
      page: PrivacyPolicyFrom.SignUpPage,
      sellerHasPrivacyPolicy: !!orgPrivacyPolicyLink,
    })
  }
  return (
    <Header className={slidesWithNoHeader.includes(index) ? "hidden" : ""}>
      {customerGoBack ? (
        <IconButton
          html={IconCrossMedium.svg}
          margin={spacing.medium}
          style={{ position: "absolute" }}
          onClick={handlecustomerGoBack}
          aria-label={text("SIGNUP_CLOSE")}
        />
      ) : (
        <IconButton
          html={IconArrowLeftMedium.svg}
          margin={spacing.medium}
          style={{ position: "absolute" }}
          onClick={handleGoBack}
          aria-label={text("SIGNUP_BACK")}
        />
      )}
      <HeaderContent alignment={Alignments.Centered}>
        {orgImageUrl && <LogoSmall src={orgImageUrl} aria-hidden />}
      </HeaderContent>
      {slidesToHideInfoIcon.includes(index) ? undefined : (
        <IconButton
          ref={ref}
          html={IconInfoMedium.svg}
          margin={spacing.medium}
          style={{ position: "absolute", right: 0 }}
          data-tooltip={text("SIGNUP_TAP_TO_LEARN_MORE_ABOUT_HOW_YOUR_DATA_IS_HANDLED")}
          onClick={handlePolicyClicked}
        />
      )}
    </Header>
  )
}
